// Import global utils
import { isEmpty } from '@automator/shared/utils/is-empty';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// Import recipe builder services
import { getItem } from '@automator/builder/services/item';

// Import recipe builder utils
import { builderFetch } from '@automator/builder/utils';

/**
 * Duplicates an action
 *
 * @param {Number} itemId The item ID
 * @return {Promise} The apiFetch promise
 */
const duplicateAction = ( itemId ) => {
	// Event name
	const eventName = 'uap/builder/core/item/duplicate-action';

	// Get the item
	const item = getItem( 'action', itemId );

	// If the item is not define, stop here
	if ( isEmpty( item ) ) {
		throw new Error( `duplicateAction: The action ${ itemId } doesn't exist` );
	}

	// Save the recipe title
	return builderFetch( {
		eventName: eventName,
		endpoint: 'duplicate_action',
		method: 'POST',
		data: {
			// eslint-disable-next-line camelcase
			recipe_id: UncannyAutomator._recipe.recipe_id,
			// eslint-disable-next-line camelcase
			action_id: itemId,
		},
		snackbar: {
			loading: escapeHTML( __( 'Duplicating item', 'uncanny-automator' ) ),
			success: escapeHTML( __( 'Item duplicated successfully', 'uncanny-automator' ) ),
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( eventName, {
				detail: {
					actionID: itemId
				}
			} ) );
		}

		return response;
	} );
}

export default duplicateAction;
